const SecurityReg = () => {
  return (
    <section
      className="col-12 ps-3 pe-3"
      style={{ maxWidth: "1000px", margin: "auto" }}
    >
      <p className="text-uppercase text-success fw-bold fs-3 pt-3 text-center">
        Chính sách bảo mật
      </p>
      <p className="fw-bold text-success">
        Chính sách bảo vệ thông tin cá nhân của người tiêu dùng bao gồm:
      </p>
      <p className="fst-italic fw-bold">
        a) Mục đích thu thập thông tin cá nhân
      </p>

      <p>
        Thông tin cá nhân của khách hàng được thu thập nhằm các mục đích sau:
        <br></br> - Phục vụ chăm sóc khách hàng trước, trong và sau bán hàng.{" "}
        <br></br> - Tích điểm thành viên để hưởng quyền lợi ưu đãi.<br></br> -
        Tặng quà trong các dịp đặc biệt như: voucher sinh nhật con, voucher sinh
        nhật mẹ, mã giảm giá, chương trình đổi hạt nhận quà.<br></br> - Gửi
        thông tin khuyến mãi, ưu đãi và cập nhật sản phẩm mới nếu khách hàng
        đồng ý nhận thông tin.<br></br> - Hỗ trợ giải đáp khiếu nại và xử lý các
        tình huống phát sinh liên quan đến đơn hàng.
      </p>

      <p className="fst-italic fw-bold">b) Phạm vi sử dụng thông tin</p>
      <p>
        Thông tin cá nhân của khách hàng chỉ được sử dụng nội bộ trong hệ thống
        của Công ty Cổ phần Thương Mại Dịch Vụ WMA nhằm mục đích:<br></br>- Hỗ
        trợ xử lý đơn hàng và chăm sóc khách hàng.<br></br>- Cung cấp thông tin
        khuyến mãi, sản phẩm mới hoặc các chương trình ưu đãi (nếu khách hàng
        đồng ý).<br></br>- Cải thiện chất lượng dịch vụ và trải nghiệm người
        dùng.<br></br>
        Chúng tôi cam kết không chia sẻ, bán hoặc cho thuê thông tin cá nhân của
        khách hàng cho bên thứ ba mà không có sự đồng ý của khách hàng, trừ khi
        có yêu cầu từ cơ quan nhà nước có thẩm quyền theo quy định pháp luật.
      </p>

      <p className="fst-italic fw-bold">c) Thời gian lưu trữ thông tin</p>
      <p>
        Thông tin cá nhân của khách hàng sẽ được lưu trữ trong hệ thống của
        chúng tôi từ thời điểm khách hàng cung cấp cho đến khi có yêu cầu hủy bỏ
        bằng văn bản từ phía khách hàng hoặc khi chúng tôi không còn phục vụ sản
        phẩm, dịch vụ liên quan đến khách hàng đó.<br></br>
        Trong mọi trường hợp, thông tin sẽ được lưu trữ tối thiểu 2 năm theo quy
        định của pháp luật.
      </p>

      <p className="fst-italic fw-bold">
        d) Những người hoặc tổ chức có thể được tiếp cận với thông tin đó
      </p>
      <p>
        - Nhân viên thuộc bộ phận chăm sóc khách hàng, bán hàng, vận hành hệ
        thống có liên quan trực tiếp đến việc xử lý đơn hàng và hỗ trợ khách
        hàng.<br></br>- Các đối tác vận chuyển có liên quan (như Viettel Post,
        J&T Express, v.v.) nhằm mục đích giao hàng cho đúng người nhận.<br></br>
        - Cơ quan nhà nước có thẩm quyền trong trường hợp có yêu cầu kiểm tra,
        thanh tra theo quy định của pháp luật.<br></br>
        Tất cả các cá nhân và tổ chức được tiếp cận thông tin đều phải cam kết
        bảo mật và sử dụng đúng mục đích.
      </p>

      <p className="fst-italic fw-bold">
        e) Địa chỉ của đơn vị thu thập và quản lý thông tin, bao gồm cách thức
        liên lạc để người tiêu dùng có thể hỏi về hoạt động thu thập, xử lý
        thông tin liên quan đến cá nhân mình
      </p>
      <p>
        Công ty Cổ phần Thương mại Dịch vụ WMA – Nhãn hàng tã bỉm Mễ Mễ Việt
        Nam.<br></br>
        Địa chỉ: Shop house TT02-24, Dự án Hải Đăng City, Phường Từ Liêm, Hà
        Nội, Việt Nam
      </p>

      <p className="fst-italic fw-bold">
        f) Phương thức và công cụ để người tiêu dùng tiếp cận và chỉnh sửa dữ
        liệu cá nhân của mình trên hệ thống thương mại điện tử của đơn vị thu
        thập thông tin.
      </p>
      <p>
        Liên hệ với bộ phận chăm sóc khách hàng qua email:
        tuvan247@memevietnam.com hoặc hotline: 0916 23 86 23 để được hỗ trợ
        chỉnh sửa/xóa thông tin.<br></br>
        Khi phát hiện thông tin cá nhân bị sử dụng sai mục đích hoặc phạm vi đã
        thông báo, khách hàng có thể liên hệ với nhãn hàng theo các thông tin đã
        nêu trên để được tiếp nhận và giải quyết, hoặc khách hàng có thể trực
        tiếp khiếu nại lên các cơ quan nhà nước có thẩm quyền theo các quy định
        của Nhà nước.
      </p>
    </section>
  );
};
export default SecurityReg;
